import { Injectable } from '@angular/core';
import { ActiveToast, IndividualConfig, ToastrService } from 'ngx-toastr';

import { DEPLOYMENT_TOAST_TEXT, isServerErrorSilenceActive } from '@services/helpers/server-error-silence';

/**
 * Replaces ToastrService app-wide (AppModule providers), so every screen's error toast — direct
 * ToastrService calls and ToasterService alike — is dropped while a 5xx is being delivered. The
 * screens' own message text is untouched; it simply never shows for a 5xx.
 * See server-error-silence.ts for how the silent turn is scoped.
 */
@Injectable()
export class SilentServerErrorToastrService extends ToastrService {
  override error(message?: string, title?: string, override?: Partial<IndividualConfig>): ActiveToast<any> {
    return isServerErrorSilenceActive() ? null : super.error(message, title, override);
  }

  override warning(message?: string, title?: string, override?: Partial<IndividualConfig>): ActiveToast<any> {
    return isServerErrorSilenceActive() ? null : super.warning(message, title, override);
  }

  override info(message?: string, title?: string, override?: Partial<IndividualConfig>): ActiveToast<any> {
    return isServerErrorSilenceActive() && message !== DEPLOYMENT_TOAST_TEXT ? null : super.info(message, title, override);
  }
}
